/* eslint-disable no-underscore-dangle */
import { Component, Input, EventEmitter, Output, ViewChildren, ViewContainerRef, QueryList } from '@angular/core';

import { DynamicComponent, GenericValue, GUIComponent, HisDynamicFieldConfig,HisValueGroup } from 'hisng';

import { DYNAMIC_FIELD_ANCHOR } from 'app/fs/res/common/model/dynamic-content/constants';
import { ProviderManager } from 'app/fs/res/common/utils/provider-manager';
import { UntypedFormGroup } from '@angular/forms';
import { DynamicContentUtils } from '../../service/dynamic-content/dynamic-content-utils';

@Component( {
    selector: 'res-classifications-tab',
    templateUrl: './classifications-tab.component.html',
    providers: [ProviderManager.getComponentProvider(ClassificationsTabComponent)],
} )
export class ClassificationsTabComponent {
    @Input() subjectAreas: GenericValue[];
    @Input() researchAreas: GenericValue[];
    @Input() researchAreasKdsf: GenericValue[];
    @Input() dynamicComponent: DynamicComponent;
    @Input() subjectAreaDdKey: string;
    @Input() researchAreaDdKey: string;
    @Input() researchAreaKdsfDdKey: string;
    @Input() editMode = true;
    @Input() changeRequestValueGroup = new HisValueGroup( 3 );
    @Input('changeRequest') set changeRequestData(changeRequest: any) {
        this.changeRequest = changeRequest;
        if (changeRequest) {
            this.subjectAreasDynamicFieldConfig =
                this.dynamicContentUtils.createDynamicFormFieldConfig(this.changeRequest._dynamicComponent, 'subjectAreas');
            this.researchAreasKdsfDynamicFieldConfig =
                this.dynamicContentUtils.createDynamicFormFieldConfig(this.changeRequest._dynamicComponent, 'researchAreasKdsf');
            this.researchAreasDynamicFieldConfig =
                this.dynamicContentUtils.createDynamicFormFieldConfig(this.changeRequest._dynamicComponent, 'researchAreas');
        } else {
            this.subjectAreasDynamicFieldConfig = null;
            this.researchAreasKdsfDynamicFieldConfig = null;
            this.researchAreasDynamicFieldConfig = null;
        }
    }
    changeRequest: any;
    public dynamicTabChildCount: GUIComponent[] = [];
    subjectAreasDynamicFieldConfig: HisDynamicFieldConfig;
    researchAreasKdsfDynamicFieldConfig: HisDynamicFieldConfig;
    researchAreasDynamicFieldConfig: HisDynamicFieldConfig;
    changeRequesForm: UntypedFormGroup = new UntypedFormGroup( {} );

    @Output() subjectAreasChange = new EventEmitter();
    @Output() researchAreasChange = new EventEmitter();
    @Output() researchAreasKdsfChange = new EventEmitter();
    @ViewChildren( DYNAMIC_FIELD_ANCHOR, { read: ViewContainerRef } ) fieldViewContainerList: QueryList<ViewContainerRef>;

    constructor(private dynamicContentUtils: DynamicContentUtils) {}

    public onSubjectAreasChange( event: GenericValue[] ) {
        this.subjectAreasChange.emit( event );
    }

    public onResearchAreasChange( event: GenericValue[] ) {
        this.researchAreasChange.emit( event );
    }

    public onResearchAreasKdsfChange( event: GenericValue[] ) {
        this.researchAreasKdsfChange.emit( event );
    }
}
